function CopyingRight() {
    return(
        <div className="copyright">
            ©2023&nbsp;中文知识分享&nbsp;
            &nbsp;|&nbsp; zh-cn.cc 版权所有
        </div>
    );
}

export default CopyingRight;